import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { auth } from './config/firebase';
import { onAuthStateChanged } from 'firebase/auth';

// 页面组件 (待创建)
import LoginPage from './pages/LoginPage';
import InstructorDashboard from './pages/InstructorDashboard';
import StudentDashboard from './pages/StudentDashboard';
import AdminPanel from './pages/AdminPanel';
import EmployerView from './pages/EmployerView';

// 样式
import './App.css';

function App() {
  const [user, setUser] = useState(null);
  const [userRole, setUserRole] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // 监听登录状态
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      setUser(currentUser);
      
      if (currentUser) {
        // 从 Firestore 获取用户角色
        // TODO: 实现角色查询
        // const role = await getUserRole(currentUser.uid);
        // setUserRole(role);
        
        // 临时: 从邮箱判断角色
        if (currentUser.email?.includes('instructor')) {
          setUserRole('instructor');
        } else if (currentUser.email?.includes('admin')) {
          setUserRole('admin');
        } else {
          setUserRole('student');
        }
      } else {
        setUserRole(null);
      }
      
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Loading MyDriveBook...</p>
        </div>
      </div>
    );
  }

  return (
    <Router>
      <div className="App min-h-screen bg-gray-50">
        <Routes>
          {/* 登录页 */}
          <Route 
            path="/login" 
            element={!user ? <LoginPage /> : <Navigate to="/" />} 
          />
          
          {/* 根据角色跳转 */}
          <Route 
            path="/" 
            element={
              !user ? (
                <Navigate to="/login" />
              ) : userRole === 'instructor' ? (
                <Navigate to="/instructor" />
              ) : userRole === 'admin' ? (
                <Navigate to="/admin" />
              ) : (
                <Navigate to="/student" />
              )
            } 
          />
          
          {/* 教练端 */}
          <Route 
            path="/instructor" 
            element={
              user && userRole === 'instructor' ? 
                <InstructorDashboard /> : 
                <Navigate to="/login" />
            } 
          />
          
          {/* 学员端 */}
          <Route 
            path="/student" 
            element={
              user && userRole === 'student' ? 
                <StudentDashboard /> : 
                <Navigate to="/login" />
            } 
          />
          
          {/* 管理员端 */}
          <Route 
            path="/admin" 
            element={
              user && userRole === 'admin' ? 
                <AdminPanel /> : 
                <Navigate to="/login" />
            } 
          />
          
          {/* 用人单位查询 */}
          <Route 
            path="/employer/:token" 
            element={<EmployerView />} 
          />
          
          {/* 404 */}
          <Route 
            path="*" 
            element={<Navigate to="/" />} 
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
